import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesCompleteChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.percentCompleteDeliveryNotes",
		title: "Complete Delivery Notes",
		yAxisLabel: "Complete (%)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.percentCompleteDeliveryNotes,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.percentCompleteDeliveryNotes );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
